module.exports = __webpack_public_path__ + "static/media/link.bfb85063.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/link.svg
// module id = 49
// module chunks = 1